'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconHeart = function IconHeart(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ height: '24', viewBox: '0 0 24 24', width: '24' }, custom),
    _react2.default.createElement('path', { d: 'm8.19095022 5.61531172c-.95700952.00429794-1.82304582.37893565-2.48851126 1.05657861-.76431823.77649574-1.1933966 1.88464972-1.17835379 3.03936479.00573061.43409268.07306511.85242618.19985454 1.24568828.15257711.6532879.95987481 2.0945328 4.87172283 5.1389119.77076516.5952656 1.92404756 1.4025634 2.54080296 1.8316417.6475573-.4477028 1.4799264-1.0880969 2.4383686-1.8789191 3.8223074-3.1303381 4.5945052-4.6052502 4.7148477-5.2055301.134669-.4648946.191975-.88680971.1862444-1.31875337-.0279367-2.20627941-1.6661708-4.00138858-3.6511059-4.00138858l-.0759304.00071633c-1.295831.01790811-2.461291.71918978-3.1195932 1.87605383-.1332363.23567076-.3810846.38180095-.6525716.38538257-.2528625-.00071632-.5214842-.13610166-.6611675-.36819079-.6819409-1.12749474-1.8495498-1.80155607-3.12460738-1.80155607zm3.93405408 13.99554778c-.1253568 0-.2528626-.0315183-.3674745-.0945548l-.0967038-.0637529-.2363871-.1647546c-.56518-.3925458-1.88751497-1.3115901-2.76286349-1.9885168-3.36099449-2.6167334-5.07730796-4.5028157-5.40466825-5.93833-.15687506-.4727741-.24928092-1.0436848-.25644416-1.63035452-.01934076-1.55800575.56804531-3.06228718 1.61459538-4.12674536.95271157-.96918703 2.20341412-1.50643039 3.52145118-1.51144466h.00143264c1.48565699 0 2.8387939.60171257 3.8122789 1.64897896.9570095-1.08594792 2.3072812-1.72061141 3.7764627-1.7406685l.0981365-.00071632c2.8144388 0 5.1353302 2.46988682 5.1747281 5.50495368.0071632.58523712-.0709162 1.15829672-.2320892 1.70341962-.2729197 1.375343-1.9870841 3.3652924-5.2241544 6.0171257-1.244972 1.0257766-2.2578548 1.7893785-3.0107119 2.2664507-.1232078.0787956-.2657564.1189098-.4075886.1189098zm5.6718573-8.6882997c.1769322 0 .3345235-.1232078.3724887-.3030052l.0408305-.163322c.0866752-.2951257.1282221-.60457788.1224915-.91689536-.0193408-1.61101377-1.1454029-2.87246118-2.5644417-2.87246118-.2098831 0-.3789356.17048523-.3789356.38108462 0 .20988307.1704852.38036831.3803683.38036831.9964073 0 1.7879459.93122183 1.8022724 2.1210368.0042979.2371034-.0279366.46990891-.0938386.69555111l-.0544405.2191953c-.0422632.2055851.0895405.4075886.2951256.4505681z', fill: color }),
    ' '
  );
};

IconHeart.propTypes = {
  color: _propTypes2.default.string
};

IconHeart.defaultProps = {
  color: _colors2.default.icons
};

IconHeart.displayName = 'IconHeart';

exports.default = IconHeart;
module.exports = exports.default;